<template>
  <b-modal
    ref="modal"
    size="lg"
    :title="`Thêm chương trình vào nhóm ${groupName || ''}`"
    hide-footer
    @shown="onShown"
  >
    <b-row class="mb-3">
      <b-col cols="8">
        <b-input
          size="sm"
          placeholder="Tìm theo tên chương trình hoặc mã voucher"
          v-model="searchText"
          v-on:keyup.enter="onSearch"
        ></b-input>
      </b-col>
      <b-col cols="4">
        <b-button size="sm" variant="primary" @click="onSearch">Tìm</b-button>
      </b-col>
    </b-row>

    <!-- A4a: báo trước có bao nhiêu chương trình sẽ bị kéo khỏi nhóm hiện tại -->
    <b-alert :show="movingCount > 0" variant="warning" class="py-2">
      <b>{{ movingCount }} chương trình</b> đã chọn đang thuộc nhóm khác, sẽ được
      chuyển sang nhóm này. Một chương trình luôn chỉ thuộc một nhóm.
    </b-alert>
    <b-alert :show="picked.length > MAX_BULK" variant="danger" class="py-2">
      Mỗi lần chỉ xử lý tối đa {{ MAX_BULK }} chương trình, vui lòng bớt bớt lựa
      chọn!
    </b-alert>

    <b-table
      :items="listData"
      :fields="fields"
      bordered
      hover
      small
      show-empty
      :busy="onLoading"
      empty-text="Không tìm thấy chương trình voucher nào"
    >
      <template v-slot:table-busy>
        <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
      </template>
      <template v-slot:cell(checkbox)="row">
        <div class="text-center">
          <b-form-checkbox
            :checked="isChecked(row.item.id)"
            @change="toggle(row.item, $event)"
          ></b-form-checkbox>
        </div>
      </template>
      <template v-slot:cell(currentGroup)="row">
        <span
          v-if="row.item.voucherGroupName"
          class="label font-weight-bold label-light-warning label-inline"
          >{{ row.item.voucherGroupName }}</span
        >
        <span v-else class="label font-weight-bold label-light label-inline"
          >chưa có</span
        >
      </template>
      <template v-slot:cell(period)="row">
        <span>Từ: {{ row.item.startDate }}</span>
        <span style="display: block">Đến: {{ row.item.endDate }}</span>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <p class="mt-2 mb-0 text-dark" style="font-weight: 500">
          Đã chọn: {{ picked.length }}
        </p>
        <b-form-text>Tích chọn áp trong phạm vi trang đang xem</b-form-text>
      </b-col>
      <b-col>
        <b-pagination
          v-show="totalPages >= 2"
          v-model="page"
          :total-rows="totalRows"
          :per-page="PAGE_SIZE"
          align="right"
          size="sm"
          @change="onPageChange"
        ></b-pagination>
      </b-col>
    </b-row>

    <div class="mt-3">
      <b-button
        size="sm"
        variant="primary"
        class="mr-2"
        :disabled="!picked.length || picked.length > MAX_BULK || isSubmitting"
        @click="confirm"
        >Thêm vào nhóm</b-button
      >
      <b-button size="sm" variant="secondary" @click="hide">Hủy</b-button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { makeToastFaile, makeToastSuccess, getApiErrorMessage } from '@/utils/common';

const MAX_BULK = 200;
const PAGE_SIZE = 10;

export default {
  components: { VclTable },
  props: {
    groupId: {
      type: [Number, String],
      default: null,
    },
    groupName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      MAX_BULK,
      PAGE_SIZE,
      onLoading: false,
      isSubmitting: false,
      searchText: '',
      listData: [],
      picked: [],
      page: 1,
      totalRows: 0,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRows / PAGE_SIZE);
    },
    /** Số chương trình đã chọn đang thuộc nhóm khác, sẽ bị kéo sang nhóm này (A4a). */
    movingCount() {
      return this.picked.filter((voucher) => voucher.voucherGroupId).length;
    },
    fields() {
      return [
        { key: 'checkbox', label: '', thStyle: { width: '6%' } },
        { key: 'name', label: 'Tên chương trình', thStyle: { width: '44%' } },
        { key: 'currentGroup', label: 'Nhóm hiện tại', thStyle: { width: '24%' } },
        { key: 'period', label: 'Thời gian', thStyle: { width: '26%' } },
      ];
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onShown() {
      this.picked = [];
      this.page = 1;
      this.searchText = '';
      this.fetchData();
    },
    isChecked(voucherId) {
      return this.picked.some((voucher) => voucher.id === voucherId);
    },
    toggle(item, checked) {
      this.picked = checked
        ? [...this.picked, item]
        : this.picked.filter((voucher) => voucher.id !== item.id);
    },
    // Tích chọn chỉ áp trong TRANG đang xem — giống màn Chi tiết nhóm. Không reset thì
    // `picked` tích lũy xuyên trang, trái chú thích dưới bảng và có thể gửi đi những
    // lựa chọn người dùng không còn nhìn thấy.
    onSearch() {
      this.page = 1;
      this.picked = [];
      this.fetchData();
    },
    onPageChange(page) {
      this.page = page;
      this.picked = [];
      this.$nextTick(this.fetchData);
    },
    fetchData() {
      this.onLoading = true;
      // Tìm theo cả tên chương trình lẫn mã voucher (use case bước A3)
      const params = {
        page: this.page,
        limit: PAGE_SIZE,
        // MỘT từ khoá tìm trên CẢ tên chương trình lẫn mã voucher. Gửi `searchName` và
        // `searchCode` cùng lúc là sai: API coi chúng là hai bộ lọc RIÊNG và AND lại,
        // nên chỉ khớp khi tên VÀ mã cùng chứa từ khoá — gần như không bao giờ.
        searchKeyword: this.searchText,
        // Loại chương trình đã thuộc chính nhóm này ở TẦNG TRUY VẤN. Lọc phía client
        // sau khi đã phân trang sẽ làm rơi dòng trong trang và khiến tổng số lệch.
        excludeVoucherGroupId: this.groupId,
      };
      ApiService.query('v2/vouchers', { params })
        .then(({ data }) => {
          this.listData = data.data.dataset;
          this.totalRows = data.data.totalRow;
          this.onLoading = false;
        })
        .catch((err) => {
          this.onLoading = false;
          makeToastFaile(getApiErrorMessage(err));
        });
    },
    async confirm() {
      this.isSubmitting = true;
      try {
        const { data } = await ApiService.post(
          `v2/voucher-groups/${this.groupId}/vouchers`,
          { voucherIds: this.picked.map((voucher) => voucher.id) },
        );
        makeToastSuccess(data.message);
        this.hide();
        this.$emit('added', data.data);
      } catch (err) {
        makeToastFaile(getApiErrorMessage(err));
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
